import { ReactElement } from 'react'
import { Box, CircularProgress, LinearProgress, Stack, Typography } from '@mui/material'
import { getTaskTitle } from '@ui/navigation/Navbar/components/RequestsWidget/taskTitles'

const percentFormatter = new Intl.NumberFormat('de-DE', {
  style: 'percent',
  maximumFractionDigits: 0,
})

interface Props {
  task: RunningTask
}

const RunningDocumentTaskRow = ({ task }: Props): ReactElement => {
  const { progress, phase } = task
  const isMerging = phase === 'merge'
  const ratio =
    progress && progress.total > 0 ? Math.min(progress.processed / progress.total, 1) : null
  const title = task.label ?? getTaskTitle(task.name)

  const status = isMerging
    ? 'Dokumente werden zusammengeführt …'
    : progress && ratio !== null
    ? `${progress.processed} / ${progress.total}`
    : null

  const progressVariant = ratio !== null && !isMerging ? 'determinate' : 'indeterminate'

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="baseline" gap={1}>
        <Typography variant="body2" noWrap title={title} sx={{ minWidth: 0 }}>
          {title}
        </Typography>
        {status && (
          <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0 }}>
            {status}
          </Typography>
        )}
      </Stack>
      <Stack direction="row" alignItems="center" gap={1}>
        <LinearProgress variant={progressVariant} value={(ratio ?? 0) * 100} sx={{ flex: 1 }} />
        {ratio !== null && !isMerging && (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ flexShrink: 0, minWidth: '4ch', textAlign: 'right' }}
          >
            {percentFormatter.format(ratio)}
          </Typography>
        )}
        {progressVariant === 'determinate' && <CircularProgress size={14} sx={{ flexShrink: 0 }} />}
      </Stack>
    </Box>
  )
}

export default RunningDocumentTaskRow
